var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.data != 0)?[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" mdi-fan mdi-spin ")])]:[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" mdi-fan")])],_vm._v("\n  "+_vm._s(_vm.label)+" "+_vm._s(_vm.index)+": "),_c('b',[_vm._v(_vm._s(_vm.data)+" %")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }